import React, { useEffect, useState } from "react";
import { IoChevronForward } from "react-icons/io5";
import Sheet from "../../../components/layout/app/Sheet";
import { DEVICE_TYPES as T, MODELS, isModel, typeOf } from "../../../constants/devices";
import { UserService } from "../../../services/UserService";
import { User } from "../../../storage/store";
import { SecurityInfo, SettingsChanges, WarrantyInfo, settingChanges } from "./InfoPages";

const firmware = (value) => {
  const number = parseFloat(value);
  return Number.isNaN(number) ? value ?? "—" : number.toFixed(1);
};

const TITLES = {
  changes: "Recent changes to settings",
  warranty: "Warranty info",
  security: "Security System Info",
};

// "Accessory Information" (app/components/SwitchInfo.js): the device's
// details, then "Recent changes to settings" (when there are any; not for
// energy meters), "Security System Info" for the security alarm, and
// "Warranty info".
const DeviceInfo = ({ open, onClose, device, lastState }) => {
  const [view, setView] = useState("info");
  const [changes, setChanges] = useState([]);
  const security = isModel(device, MODELS.WZLTEG_1);
  const showChanges = typeOf(device) !== T.ENERGY_METER && changes.length > 0;

  useEffect(() => {
    if (!open) {
      setView("info");
      return undefined;
    }
    let current = true;
    UserService.getActivitybyId(User.getPropertyId(), device.applianceId)
      .then((result) => current && setChanges(settingChanges(result?.data)))
      .catch(() => current && setChanges([]));
    return () => {
      current = false;
    };
  }, [open, device.applianceId]);

  const rows = [
    ["Device ID", device.deviceId],
    ["Model", device.meta?.model],
    ["Build", lastState?.build],
    ["Firmware Version", lastState?.firmwareVersion ? firmware(lastState.firmwareVersion) : null],
    ["Vendor ID", device.meta?.vendorId],
    ["Signal Strength (dBm)", lastState?.rssi],
  ];
  if (lastState?.mcuFirmwareVersion) rows.push(["MCU Version", Number(lastState.mcuFirmwareVersion) / 10]);

  const back = () => setView("info");
  const more = [
    showChanges ? ["changes", TITLES.changes] : null,
    security ? ["security", TITLES.security] : null,
    ["warranty", TITLES.warranty],
  ].filter(Boolean);

  return (
    <Sheet open={open} onClose={onClose} title={TITLES[view] ?? "Accessory Information"}>
      {view === "security" ? <SecurityInfo device={device} lastState={lastState} onBack={back} /> : null}
      {view === "changes" ? <SettingsChanges changes={changes} onBack={back} /> : null}
      {view === "warranty" ? <WarrantyInfo device={device} onBack={back} /> : null}
      {view === "info" ? (
        <div className="hx-info">
          <h3 className="hx-info-name">{device.name}</h3>
          <dl className="hx-info-card">
            {rows.map(([title, value]) => (
              <div className="hx-info-row" key={title}>
                <dt>{title}</dt>
                <dd>{value ?? "—"}</dd>
              </div>
            ))}
          </dl>
          {more.map(([key, title]) => (
            <button key={key} type="button" className="hx-info-link" onClick={() => setView(key)}>
              {title}
              <IoChevronForward aria-hidden="true" />
            </button>
          ))}
          <p className="hx-info-foot">
            <b>Manufacturer:</b>
            <span>HASHh Automations. Connected through HASHh Cloud.</span>
          </p>
        </div>
      ) : null}
    </Sheet>
  );
};

export default DeviceInfo;
